import React from 'react';
import CabCrudPage from './CabCrudPage';
import useCabLookups from './useCabLookups';

const AdminCabsCabPackages = () => {
  const { vehicleCategories, seatConfigs, locations } = useCabLookups();

  return (
    <CabCrudPage
      title="Cab Packages"
      description="Manage hourly and distance-based cab packages."
      resource="cab-packages"
      defaultItem={{
        name: '',
        slug: '',
        description: '',
        locationId: '',
        vehicleCategoryId: '',
        seatConfigId: '',
        tripType: 'ONEWAY',
        hoursIncluded: 4,
        kmIncluded: 40,
        baseFare: 0,
        extraHourRate: 0,
        extraKmRate: 0,
        currency: 'INR',
        isActive: true,
      }}
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'slug', label: 'Slug' },
        {
          key: 'location',
          label: 'Location',
          render: (row) => row.location?.name || '�',
        },
        { key: 'hoursIncluded', label: 'Hours' },
        { key: 'kmIncluded', label: 'Km' },
      ]}
      fields={[
        { name: 'name', label: 'Name', required: true },
        { name: 'slug', label: 'Slug', required: true },
        { name: 'description', label: 'Description', type: 'textarea', col: 'col-12' },
        {
          name: 'locationId',
          label: 'Location',
          type: 'select',
          required: true,
          options: locations.map((l) => ({ value: l.id, label: l.name })),
        },
        {
          name: 'vehicleCategoryId',
          label: 'Vehicle category',
          type: 'select',
          required: true,
          options: vehicleCategories.map((c) => ({ value: c.id, label: c.name })),
        },
        {
          name: 'seatConfigId',
          label: 'Seat configuration',
          type: 'select',
          required: true,
          options: seatConfigs.map((c) => ({ value: c.id, label: c.name })),
        },
        {
          name: 'tripType',
          label: 'Trip type',
          type: 'select',
          options: [
            { value: 'ONEWAY', label: 'One-way' },
            { value: 'ROUNDTRIP', label: 'Round trip' },
          ],
        },
        { name: 'hoursIncluded', label: 'Hours included', type: 'number', required: true },
        { name: 'kmIncluded', label: 'Km included', type: 'number', required: true },
        { name: 'baseFare', label: 'Base fare', type: 'number', required: true },
        { name: 'extraHourRate', label: 'Extra hour rate', type: 'number', required: true },
        { name: 'extraKmRate', label: 'Extra km rate', type: 'number', required: true },
        { name: 'currency', label: 'Currency' },
        { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
      ]}
    />
  );
};

export default AdminCabsCabPackages;
